import Dexie from "dexie";
import type { ITblMServiceData } from "@/models/TblMService";
import { TblMService } from "@/models/TblMService";
import { TblMServiceKomoku } from "@/models/TblMServiceKomoku";
import MyCommon from "@/Js/MyCommon";

const myCommon = new MyCommon();
// Dexie データベースの初期化
class MyServiceDatabase extends Dexie {
  tblMService: Dexie.Table<TblMService, string>; // プライマリキー型は適宜変更
  tblMServiceKomoku: Dexie.Table<TblMServiceKomoku, string>; // プライマリキー型は適宜変更
  constructor() {
    super("MyDatabase");
    this.version(1).stores({
      tblMService: "++id, serviceType,serviceCode, kaisibi", // 適宜インデックスを設定
      tblMServiceKomoku: "++id, serviceType", // 適宜インデックスを設定
    });
    this.tblMService = this.table("tblMService");
    this.tblMServiceKomoku = this.table("tblMServiceKomoku");
  }

  // async getService(
  //   serviceType: string,
  //   serviceCode: string,
  //   dtmTeikyoTuki: Date
  // ): Promise<TblMService | null> {
  //   try {
  //     // dtmTeikyoTuki を "yyyyMMdd" にフォーマット
  //     const teikyoTuki = myCommon.formatDateToYYYYMMDD(dtmTeikyoTuki);
  //     // IndexedDB で条件検索
  //     const matchingRecords = await this.tblMService
  //       .where("serviceType")
  //       .equals(String(serviceType))
  //       .and(
  //         (item) =>
  //           String(item.serviceCode) === String(serviceCode) &&
  //           String(item.kaisibi) <= teikyoTuki &&
  //           (item.shuryobi === "99999999" || String(item.shuryobi) >= teikyoTuki) // 特殊条件考慮
  //       )
  //       .toArray(); // 必ず配列として取得
  
  //     // レコードがない場合は null を返す
  //     if (!matchingRecords || matchingRecords.length === 0) {
  //       return null;
  //     }
 
  //     const service:TblMService= new TblMService({
  //       ...matchingRecords[0], // 最初のレコードを選択
  //     });

  //     return service;

  //   } catch (error) {
  //     console.error("Error in getService:", error);
  //     return null; // エラー時は null を返す
  //   }
  // }

  // async getServices(
  //   serviceType: string,
  //   dtmTeikyoTuki: Date
  // ): Promise<TblMService[] | null> {
  //   try {
  //     // dtmTeikyoTuki を "yyyyMMdd" にフォーマット
  //     const teikyoTuki = myCommon.formatDateToYYYYMMDD(dtmTeikyoTuki);
  //     // IndexedDB で条件検索
  //     const matchingRecords = await this.tblMService
  //       .where("serviceType")
  //       .equals(String(serviceType))
  //       .and(
  //         (item) =>
  //            String(item.kaisibi) <= teikyoTuki &&
  //           (item.shuryobi === "99999999" || String(item.shuryobi) >= teikyoTuki) // 特殊条件考慮
  //       )
  //       .toArray(); // 必ず配列として取得
  
  //     // レコードがない場合は null を返す
  //     if (!matchingRecords || matchingRecords.length === 0) {
  //       return null;
  //     }
 
  //     const services:TblMService[] = matchingRecords.map((item: ITblMServiceData) => {
  //        return new TblMService({ 
  //         ...item,
  //         isSelect:false
  //        });
  //     });

  //     return services;

  //   } catch (error) {
  //     console.error("Error in getService:", error);
  //     return null; // エラー時は null を返す
  //   }
  //}


}  
// // クラスをエクスポート
export default new MyServiceDatabase();
